import { BasketStorageItem } from "./BasketStorageItem";
import { IBasketStorage } from "./IBasketStorage";


export class BasketLocalStorage implements IBasketStorage
{
    private KEY = 'basket';

    public Update(items: BasketStorageItem[]): void
    {
        localStorage.setItem(this.KEY, JSON.stringify(items));
    }

    public Clear(): void
    {
        localStorage.removeItem(this.KEY);
    }

    public Get(): BasketStorageItem[]
    {
        return JSON.parse(localStorage.getItem(this.KEY) ?? "[]");
    }
}
